/**
 * Jewelry Factory — header interactions
 */
(function () {
  'use strict';

  function initCountdown() {
    const countdownEl = document.getElementById('jf-countdown');
    if (!countdownEl) return;

    const tick = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      let s = Math.max(0, Math.floor((end - now) / 1000));
      const d = Math.floor(s / 86400);
      s %= 86400;
      const h = Math.floor(s / 3600);
      s %= 3600;
      const m = Math.floor(s / 60);
      s %= 60;
      countdownEl.textContent = `${d}d : ${h}h : ${m}m : ${s}s`;
    };

    tick();
    setInterval(tick, 1000);
  }

  function initStickyHeader() {
    const header = document.getElementById('jf-header');
    if (!header) return;

    let lastScrolled = false;
    window.addEventListener(
      'scroll',
      () => {
        const scrolled = window.scrollY > 60;
        if (scrolled !== lastScrolled) {
          header.classList.toggle('is-scrolled', scrolled);
          lastScrolled = scrolled;
        }
      },
      { passive: true }
    );
  }

  function initMegaMenus() {
    document.querySelectorAll('.jf-nav__item.has-mega > .jf-nav__link').forEach((link) => {
      link.addEventListener('click', (e) => {
        const item = link.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          document.querySelectorAll('.jf-nav__item.is-open').forEach((o) => {
            if (o !== item) {
              o.classList.remove('is-open');
              const siblingLink = o.querySelector('.jf-nav__link');
              if (siblingLink) siblingLink.setAttribute('aria-expanded', 'false');
            }
          });
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.jf-nav__item.has-mega')) {
        document.querySelectorAll('.jf-nav__item.is-open').forEach((o) => {
          o.classList.remove('is-open');
          const link = o.querySelector('.jf-nav__link');
          if (link) link.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function initSearch() {
    const search = document.getElementById('jf-search');
    const searchToggle = document.getElementById('jf-searchToggle');
    const searchInput = search?.querySelector('.jf-search__input');
    const searchPanel = search?.querySelector('.jf-search__panel');
    const searchStatic = search?.querySelector('[data-jf-search-static]');
    const predictive = search?.querySelector('predictive-search');

    if (!search || !searchInput || !searchPanel) return;

    const isCollapsibleSearch = () => true;

    const setPanelOpen = (open) => {
      searchPanel.classList.toggle('is-open', open);
    };

    const setSearchOpen = (open) => {
      search.classList.toggle('is-open', open);
      if (searchToggle) {
        searchToggle.setAttribute('aria-expanded', String(open));
      }
      if (!open) {
        setPanelOpen(false);
      }
    };

    const syncStatic = () => {
      const hasQuery = searchInput.value.trim().length > 0;
      const liveOpen = predictive?.hasAttribute('open');
      searchStatic?.classList.toggle('is-hidden', hasQuery && liveOpen);
    };

    searchInput.addEventListener('focus', () => {
      setSearchOpen(true);
      setPanelOpen(true);
      syncStatic();
    });

    searchInput.addEventListener('input', () => {
      setSearchOpen(true);
      setPanelOpen(true);
      if (!searchInput.value.trim()) {
        syncStatic();
      }
    });

    if (predictive) {
      new MutationObserver(() => {
        if (predictive.hasAttribute('open') || predictive.hasAttribute('loading')) {
          setSearchOpen(true);
          setPanelOpen(true);
        }
        syncStatic();
      }).observe(predictive, {
        attributes: true,
        attributeFilter: ['open', 'loading'],
      });
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', () => {
        const open = !search.classList.contains('is-open');
        setSearchOpen(open);
        if (open) {
          const mobileNav = document.getElementById('jf-mobileNav');
          const menuToggle = document.getElementById('jf-menuToggle');
          if (mobileNav?.classList.contains('is-open')) {
            mobileNav.classList.remove('is-open');
            mobileNav.setAttribute('aria-hidden', 'true');
            menuToggle?.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
          }
          searchInput.focus();
        }
      });
    }

    document.addEventListener('click', (e) => {
      const clickedToggle = searchToggle?.contains(e.target);
      if (!search.contains(e.target) && !clickedToggle) {
        setPanelOpen(false);
        setSearchOpen(false);
      }
    });

    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        setPanelOpen(false);
        setSearchOpen(false);
        searchInput.blur();
      }
    });
  }

  function initMobileNav() {
    const menuToggle = document.getElementById('jf-menuToggle');
    const mobileNav = document.getElementById('jf-mobileNav');
    if (!menuToggle || !mobileNav) return;

    const scrim = mobileNav.querySelector('.jf-mobile-nav__scrim');

    const setOpen = (open) => {
      mobileNav.classList.toggle('is-open', open);
      mobileNav.setAttribute('aria-hidden', String(!open));
      menuToggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };

    menuToggle.addEventListener('click', () => {
      const opening = !mobileNav.classList.contains('is-open');
      setOpen(opening);
      if (opening) {
        const search = document.getElementById('jf-search');
        const searchToggle = document.getElementById('jf-searchToggle');
        const searchPanel = search?.querySelector('.jf-search__panel');
        search?.classList.remove('is-open');
        searchPanel?.classList.remove('is-open');
        searchToggle?.setAttribute('aria-expanded', 'false');
      }
    });

    if (scrim) {
      scrim.addEventListener('click', () => setOpen(false));
    }

    mobileNav.querySelectorAll('a').forEach((a) => {
      a.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        setOpen(false);
        menuToggle.focus();
      }
    });
  }

  function init() {
    initCountdown();
    initStickyHeader();
    initMegaMenus();
    initSearch();
    initMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
